import { FC, MutableRefObject } from 'react'
import { GridRenderCellParams } from '@microservices/wiskey-react-table-component'

import { isBottomPinnedTotalRow, isGroupTitleRow } from '@components/TimeLineGrid/helpers'
import { useHandlers } from '@components/TimeLineGrid/hooks'

import { useAppSelector } from '@hooks'
import { cellRenderer } from '@helpers'
import { ConfiguredColumn, TimelineCellContext } from '@types'

type Props = {
  params: GridRenderCellParams
  item: ConfiguredColumn
  handlers: ReturnType<typeof useHandlers>
  cellContextRef: MutableRefObject<TimelineCellContext>
}

export const ObjectXCell: FC<Props> = props => {
  const { params, item, cellContextRef } = props

  const variables = useAppSelector(state => state.timeLineGrid.variables)

  if (isGroupTitleRow(params.row.id) || isBottomPinnedTotalRow(params.row.id)) {
    return ''
  }

  return cellRenderer(
    { ...item, code: item.value },
    {
      ...params,
      row: {
        ...params.row,
        variables,
        objectYTotalCount: cellContextRef.current.objectYTotalCount,
      },
    },
    false
  )
}
